import { formatPriceInput } from '@dashboard/services/formatting';

import draftToNestedPrice from './draftToNestedPrice';
import { fromStartDateInput } from './startDateInput';

/**
 * The submit boundary of the flat price Formik tree (spec §7): convert a single
 * price draft's money fields from dollars to cents, turn the datetime-local
 * start date (entered in UTC) back into a Date, and nest the flat billing
 * fields into recurring XOR paymentPlan.
 *
 * `key` is deliberately preserved — ProductService.update matches a temporary
 * defaultPriceId (e.g. "price-3") to the right price index by it.
 */
export default function draftToPricePayload(price, fallbackCurrency) {
  const currency = price.currency || fallbackCurrency || 'usd';

  return draftToNestedPrice({
    ...price,
    // A cleared amount persists as an EMPTY price (null) — a price may carry
    // just a billing type. ('0' still converts to 0 cents.)
    amount:
      String(price.amount ?? '').trim() === '' ? null : formatPriceInput(price.amount, currency),
    discountedFromPrice: price.discountedFromPrice
      ? formatPriceInput(price.discountedFromPrice, currency)
      : price.discountedFromPrice,
    setupFee: price.setupFee ? formatPriceInput(price.setupFee, currency) : price.setupFee,
    pwywSuggestedPrice: price.pwywSuggestedPrice
      ? formatPriceInput(price.pwywSuggestedPrice, currency)
      : price.pwywSuggestedPrice,
    startDate: price.startDate ? fromStartDateInput(price.startDate) : null,
  });
}
